import { render, staticRenderFns } from "./WalletsTab.vue?vue&type=template&id=1e928bd4&scoped=true"
import script from "./WalletsTab.vue?vue&type=script&lang=js"
export * from "./WalletsTab.vue?vue&type=script&lang=js"
import style0 from "./WalletsTab.vue?vue&type=style&index=0&id=1e928bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e928bd4",
  null
  
)

export default component.exports